import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminComponent } from './containers/admin/admin.component'
import { ChartsModule } from 'ng2-charts'
import { SharedModule } from '../shared/shared.module';
import { AdminLoginComponent } from './containers/admin-login/admin-login.component'
import { FormsModule } from '@angular/forms'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,

    ChartsModule,

    SharedModule
  ],
  declarations: [
    AdminComponent,
    AdminLoginComponent
  ],
  exports: [
    AdminComponent
  ]
})
export class AdminModule { }



// WEBPACK FOOTER //
// C:/Users/Thomas/Projekte/palettes/src/app/admin/admin.module.ts